// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KurssloeyfeElementIcon-module__icon__kcAzG {\n  min-height: 32px;\n  min-width: 32px;\n}\n", "",{"version":3,"sources":["webpack://./src/domain/kurssloeyfe/KurssloeyfeElementIcon.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".icon {\n  min-height: 32px;\n  min-width: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "KurssloeyfeElementIcon-module__icon__kcAzG"
};
export default ___CSS_LOADER_EXPORT___;
